<div
  [ngClass]="{ 'full-height': mode === 'page', 'full-width': mode === 'page' }"
  class="content-container"
>
  <p-dialog
    class="otpDialog"
    [(visible)]="displayOtpDialog"
    [modal]="true"
    [closable]="true"
    (onHide)="onDialogHide()"
    *ngIf="mode === 'dialog'"
  >
    <ng-template pTemplate="header">
      <div class="otp-dialog-header">
        <button class="back-button-mobile" (click)="onDialogHide()">
          <i class="pi pi-arrow-left"></i>
        </button>
      </div>
    </ng-template>
    <ng-container *ngTemplateOutlet="otpContent"></ng-container>
  </p-dialog>

  <!-- Conditionally render content directly if mode is 'page' -->
  <div class="page-container" *ngIf="mode === 'page'">
    <p-card>
      <ng-container *ngTemplateOutlet="otpContent"></ng-container>
    </p-card>
  </div>

  <!-- Render content inline without any wrapper for nested dialogs -->
  <div *ngIf="mode === 'inline'">
    <ng-container *ngTemplateOutlet="otpContent"></ng-container>
  </div>

  <ng-template #otpContent>
    <div
      *ngIf="vm$ | async as vm"
      [ngStyle]="{ display: showAuthenticationCodeDialog ? 'none' : 'block' }"
    >
      <!-- Show different content based on twoFactorAuthMethod and isTotpMode -->
      <ng-container *ngIf="twoFactorAuthMethod === 'TOTP' && isTotpMode; else otpContent">
        <!-- TOTP/Authenticator App Content -->
        <div class="p-card-title">Authentication Code</div>
        <div class="p-card-subtitle">
          Please enter the 6-digit verification code from your authenticator app.
        </div>
        <div>
          <code-input
            #codeInput
            class="otp-input invalid"
            [isCodeHidden]="false"
            [codeLength]="6"
            [isCharsCode]="false"
            (codeChanged)="onCodeChanged($event)"
            [ngClass]="{
              'invalid shake': vm.errorMessage && !vm.isSuspendAccount,
            }"
          >
          </code-input>

          <p
            class="warning-message"
            [ngStyle]="{
              color: vm.errorMessage && !vm.isSuspendAccount ? 'red' : '#929292',
            }"
            *ngIf="vm.errorMessage"
          >
            <span [innerHTML]="vm.errorMessage"></span>
          </p>
        </div>
      </ng-container>

      <!-- OTP Content -->
      <ng-template #otpContent>
        <div class="p-card-title">Verification Code</div>
        <div class="p-card-subtitle" [innerHTML]="getResendMessage(vm.resendDelaySeconds)"></div>
        <div>
          <code-input
            #codeInput
            class="otp-input invalid"
            [isCodeHidden]="false"
            [codeLength]="6"
            [isCharsCode]="false"
            (codeChanged)="onCodeChanged($event)"
            [ngClass]="{
              'invalid shake': vm.errorMessage && !vm.isSuspendAccount,
            }"
          >
          </code-input>

          <p
            class="warning-message"
            [ngStyle]="{
              color: vm.errorMessage && !vm.isSuspendAccount ? 'red' : '#929292',
            }"
            *ngIf="vm.errorMessage"
          >
            <span [innerHTML]="vm.errorMessage"></span>
          </p>
          <div class="p-card-subtitle">
            <ng-container *ngIf="vm.isCountdownActive">
              Not received? Send a new code in <strong>{{ formatCountdown(vm.countdown) }}</strong>
            </ng-container>
            <ng-container *ngIf="!vm.isCountdownActive && !vm.isSuspendAccount">
              Not received?
              <span class="resend" (click)="resendOtpCode()">Resend Code</span>
            </ng-container>
          </div>
        </div>
      </ng-template>

      <!-- Try Another Method button -->
      <div class="try-another-method" *ngIf="showTryAnotherMethod()">
        <button type="button" class="try-another-button" (click)="openVerificationMethodDialog()">
          Try Another Method
        </button>
      </div>

      <app-block-loading [show]="vm.isLoading"></app-block-loading>
    </div>

    <!-- Verification Method Selection Dialog -->
    <p-dialog
      [(visible)]="showVerificationMethodDialog"
      [modal]="true"
      [closable]="true"
      [draggable]="false"
      [resizable]="false"
      [appendTo]="'body'"
      styleClass="verification-method-dialog"
      (onHide)="closeVerificationMethodDialog()"
    >
      <div class="verification-method-content">
        <div class="close-button-method" (click)="closeVerificationMethodDialog()">
          <i class="pi pi-times"></i>
        </div>

        <div class="method-header">
          <h2>Verification Method</h2>
          <p>Select one of the verification method below to receive a verification code</p>
        </div>

        <div class="method-options">
          <!-- Authenticator App Option -->
          <div class="method-option" (click)="selectAuthenticatorMethod()">
            <div class="method-icon">
              <img
                src="assets/icon/authenticator.svg"
                alt="Authenticator App"
                class="method-icon-image"
              />
            </div>
            <div class="method-details">
              <h3>Authenticator App</h3>
              <p>
                Use an authenticator app such as Google Authenticator, Microsoft Authenticator, or
                Authy to generate a 6-digit verification code.
              </p>
            </div>
            <div class="method-arrow">
              <i class="pi pi-chevron-right"></i>
            </div>
          </div>

          <!-- OTP via Email Option -->
          <div class="method-option" (click)="selectOTPMethod()">
            <div class="method-icon">
              <img src="assets/icon/input-pin.svg" alt="Input OTP" class="method-icon-image" />
            </div>
            <div class="method-details">
              <h3>One-Time Password (OTP) via Email</h3>
              <p>We'll send a 6-digit verification code to your registered email</p>
            </div>
            <div class="method-arrow">
              <i class="pi pi-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
    </p-dialog>

    <!-- Authentication Code Dialog (for ACTIVE TOTP users) -->
    <p-dialog
      [(visible)]="showAuthenticationCodeDialog"
      [modal]="true"
      [closable]="true"
      [draggable]="false"
      [resizable]="false"
      [appendTo]="'body'"
      styleClass="authentication-code-dialog"
      (onHide)="closeAuthenticationCodeDialog()"
    >
      <div class="authentication-code-content">
        <div class="close-button-auth" (click)="closeAuthenticationCodeDialog()">
          <i class="pi pi-times"></i>
        </div>

        <div class="p-card-title">Authentication Code</div>
        <div class="p-card-subtitle">Enter the 6-digit code sent from your authenticator app</div>

        <div class="auth-code-input-section">
          <code-input
            #authCodeInput
            class="otp-input"
            [isCodeHidden]="false"
            [codeLength]="6"
            [isCharsCode]="false"
            (codeChanged)="onAuthCodeChanged($event)"
          >
          </code-input>
        </div>

        <!-- Error message display -->
        <div *ngIf="authCodeError" class="auth-code-error">
          {{ authCodeError }}
        </div>

        <div class="try-another-method">
          <button
            type="button"
            class="try-another-button"
            (click)="openVerificationMethodDialogFromAuth()"
          >
            Try Another Method
          </button>
        </div>
      </div>
    </p-dialog>
  </ng-template>
</div>
